import { computed, Ref } from '@nuxtjs/composition-api';
import { GlobalConfig } from '@shared/types/GlobalConfig';
import { IBreakpoint } from '@shared/types/IBreakpoint';

import { IConfig } from '../types';

const MOBILE_MARGIN = '16px';

const useStyles = (
  config: Ref<IConfig>,
  globalConfig: GlobalConfig,
  breakpoint: Ref<IBreakpoint>,
) => {
  const styles = computed(() => {
    config.value.cardSpacing =
      typeof config.value.cardSpacing === 'number'
        ? `${config.value.cardSpacing}px`
        : config.value.cardSpacing;

    return {
      header: {
        ...config.value.headerStyle,
        ...config.value.titleStyle,
      },
      group: {
        margin:
          config.value.cardMode === 'scroll' && breakpoint.value.name === 'mobile'
            ? `0 -${MOBILE_MARGIN}`
            : '0',
        padding: globalConfig.cardShadow ? '0 8px 10px' : '0 0 10px 0',
        ...config.value.groupStyle,
      },
      groupInner: {
        overflowX: config.value.cardMode === 'scroll' ? 'scroll' : 'hidden',
        flexWrap: config.value.cardMode === 'wrap' ? 'wrap' : 'nowrap',
        margin: `0 calc(${config.value.cardSpacing} / -2)`,
        padding:
          config.value.cardMode === 'scroll' && breakpoint.value.name === 'mobile'
            ? `0 ${MOBILE_MARGIN}`
            : '0',
      },
      cardContainer: {
        flexBasis: config.value.cardFlexBasis,
        flexGrow: config.value.cardFlexGrow,
        padding: `calc(${config.value.cardSpacing} / 2)`,
        'padding-bottom': `${config.value.paddingBottom}`,
      },
    };
  });

  return {
    styles,
  };
};

export default useStyles;
